import { render } from "./SaveCandidate.vue?vue&type=template&id=ab53ac08&scoped=true"
import script from "./SaveCandidate.vue?vue&type=script&lang=js"
export * from "./SaveCandidate.vue?vue&type=script&lang=js"

import "./SaveCandidate.vue?vue&type=style&index=0&id=ab53ac08&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab53ac08"]])

export default __exports__